import { Fragment } from "react";
import { useSnackbar } from "notistack";
import { useIntl } from "react-intl";

import { FormWrapper } from "@dzambalaorg/mui-form";
import { EntityInput } from "@dzambalaorg/mui-inputs-entity";
import { IMerchantSettings, SettingsKeys } from "@framework/types";
import { PageHeader } from "@dzambalaorg/mui-page-layout";
import { useMutationQuery } from "@dzambalaorg/react-hooks";
import { FormGrid } from "@dzambalaorg/ui-kit";

import { ITabPanelProps } from "../tabs";
import { validationSchema } from "./validation";

export const MerchantSettings = (props: ITabPanelProps) => {
  const { open } = props;

  const { enqueueSnackbar } = useSnackbar();
  const { formatMessage } = useIntl();

  const { mutateAsync } = useMutationQuery("/settings", "PUT", void 0, {
    onSuccess: () => {
      enqueueSnackbar(formatMessage({ id: "snackbar.updated" }), { variant: "success" });
    },
  });

  const handleSubmit = async (values: Partial<IMerchantSettings>) => {
    const { ...data } = values;
    await mutateAsync({
      data: {
        settings: {
          [SettingsKeys.EXCLUDED_MERCHANTS]: data.merchantIds,
        },
      },
    });
  };

  if (!open) {
    return null;
  }

  return (
    <Fragment>
      <PageHeader message="pages.merchant.tabs.settings" />

      <FormWrapper initialValues={{ merchantIds: [] }} validationSchema={validationSchema} onSubmit={handleSubmit}>
        <FormGrid
          columns={[1]}
          containerProps={{ sx: theme => ({ marginBottom: theme.spacing(theme.tokens.spacing.xl) }) }}
        >
          <EntityInput
            multiple
            label={formatMessage({ id: "form.labels.excludedMerchants" })}
            name="merchantIds"
            controller="merchants"
          />
        </FormGrid>
      </FormWrapper>
    </Fragment>
  );
};
